/* eslint-disable no-underscore-dangle */
import * as Router from "react-router";
import * as Sentry from "@sentry/react";
import routes from "routes/index";

if (window.__ENABLED_ANALYTICS__.sentry) {
  Sentry.init({
    dsn: window.__SENTRY_URL__,
    environment: window.__ENV_,
    integrations: [
      Sentry.reactRouterV3BrowserTracingIntegration({
        history: Router.browserHistory,
        // Must be Plain Routes.
        routes: Router.createRoutes(routes),
        match: Router.match
      }),
      window.__ENABLED_ANALYTICS__.sentryReplay
        ? Sentry.replayIntegration({
            // Additional SDK configuration goes in here, for example:
            maskAllText: false,
            blockAllMedia: false
          })
        : null
    ].filter(i => i),

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 1.0,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0
  });
}
